import React from "react";
import PropTypes from "prop-types";

import { Flex, Indicator } from "@sopranodesign/pulse-components";

const ProjectStatus = ({ enabled }) => (
  <Flex left center xSpaceSm>
    <Indicator colour={enabled ? "positive" : "danger"} />
    <div>{enabled ? "Enabled" : "Disabled"}</div>
  </Flex>
);

ProjectStatus.propTypes = {
  enabled: PropTypes.bool,
};

export default ProjectStatus;
